import { useContext, useMemo } from 'react'
import IntlContext from './IntlContext'
import { MessageFormat } from '@paypalcorp/worldready'

const createFormatters = (worldReady) => {
  return {
    formatMessage: (message = '', variables?) => {
      return new MessageFormat(worldReady, message.split('.')).format(variables)
    },
  }
}

/**
 * Refer to Worldready documentation for more information:
 * https://github.paypal.com/pages/Globalization-R/worldReady-js/
 */
export default function useMessageFormat(worldReadyObject?: any) {
  const { worldReady } = useContext(IntlContext)

  const formatters = useMemo(() => {
    return createFormatters(worldReady || worldReadyObject)
  }, [worldReady, worldReadyObject])

  return formatters
}
